import OrderStatus from 'components/Content/CustomerService/OrderStatus/OrderStatus';

export default OrderStatus;
